// Copyright © 2026 Gian Marco Cappelli — SAPIENS (finsapiens.it). Tutti i diritti riservati. Sviluppato su commissione esclusiva. Vietata la riproduzione senza autorizzazione scritta.
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const cards = [
  {
    icon: '🆓',
    title: 'Gratuito nella base',
    text: 'I percorsi fondamentali, gli strumenti essenziali e il glossario sono e rimarranno sempre gratuiti.',
  },
  {
    icon: '🔒',
    title: 'Indipendente',
    text: 'Nessuna pubblicità, nessun prodotto in vendita, nessun conflitto di interesse. Solo educazione finanziaria onesta.',
  },
  {
    icon: '🇮🇹',
    title: 'Pensato per l\'Italia',
    text: 'Normativa italiana aggiornata: IRPEF 2026, novità TFR luglio 2026, ISEE, mutui, fondi pensione. Non contenuti generici.',
  },
];

const AboutPage = () => (
  <div className="min-h-screen bg-[#1C1C1A] py-16 px-4" data-testid="about-page">
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-[800px] mx-auto"
    >
      {/* Title */}
      <h1 style={{ fontSize: '2.4rem', fontWeight: 700, color: '#E8E8E4', marginBottom: 32, lineHeight: 1.2 }}>
        Perché esiste SAPIENS
      </h1>

      {/* Section 1 */}
      <p className="text-base text-[#888780] leading-relaxed mb-8" style={{ maxWidth: 680 }}>
        In Italia l'educazione finanziaria non si insegna a scuola. Il risultato è che milioni di persone arrivano al primo
        stipendio, al primo mutuo, alla pensione senza gli strumenti per decidere in modo consapevole. Non è colpa loro — è
        un gap strutturale del sistema educativo italiano.
      </p>

      {/* Section 2 */}
      <p className="text-base text-[#888780] leading-relaxed mb-12" style={{ maxWidth: 680 }}>
        SAPIENS nasce per colmare questo gap. Non siamo una banca. Non vendiamo prodotti finanziari. Non abbiamo conflitti di
        interesse. Siamo una piattaforma educativa indipendente con un obiettivo: rendere l'educazione finanziaria accessibile
        a tutti, in italiano, senza gergo tecnico.
      </p>

      {/* Cards */}
      <div className="grid sm:grid-cols-3 gap-6 mb-14">
        {cards.map((card) => (
          <motion.div
            key={card.title}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            className="p-6 rounded-2xl"
            style={{ background: '#252523', border: '1px solid rgba(255,255,255,0.06)' }}
          >
            <div className="text-3xl mb-4">{card.icon}</div>
            <h3 className="text-base font-semibold text-[#E8E8E4] mb-2">{card.title}</h3>
            <p className="text-sm text-[#888780] leading-relaxed">{card.text}</p>
          </motion.div>
        ))}
      </div>

      {/* CTA */}
      <Link
        to="/percorsi"
        className="sapiens-btn-primary inline-flex items-center gap-2 px-8 py-3 text-base"
        data-testid="about-cta"
      >
        Inizia il tuo percorso →
      </Link>
    </motion.div>
  </div>
);

export default AboutPage;
